import {
    Buildings,
    Category,
    Element3,
    Tag,
    Teacher,
    Hierarchy,
    House2,
    Camera,
    TaskSquare,
    DocumentText,
    Box,
    Setting2,
    Data,
} from "iconsax-react";

const icons = {
    masterData: Data,
    buildings: Buildings,
    category: Category,
    element3: Element3,
    tag: Tag,
    teacher: Teacher,
    hierarchy: Hierarchy,
    house: House2,
    camera: Camera,
    task: TaskSquare,
    doc: DocumentText,
    box: Box,
    setting: Setting2,
};

// 12 flat rows collapsed into one "Master Data" parent — this was the single
// biggest contributor to sidebar length.
const masterDataItem = {
    id: "master-data-group",
    type: "group",
    children: [
        {
            id: "master-data",
            title: "Master Data",
            type: "collapse",
            icon: icons.masterData,
            children: [
                {
                    id: "buildings",
                    title: "Buildings",
                    type: "item",
                    url: "/master-data/buildings",
                    icon: icons.buildings,
                    breadcrumbs: true,
                },
                {
                    id: "floors",
                    title: "Floors",
                    type: "item",
                    url: "/master-data/floors",
                    icon: icons.hierarchy,
                    breadcrumbs: true,
                },
                {
                    id: "rooms",
                    title: "Rooms / Areas",
                    type: "item",
                    url: "/master-data/rooms",
                    icon: icons.house,
                    breadcrumbs: true,
                },
                {
                    id: "departments",
                    title: "Departments",
                    type: "item",
                    url: "/master-data/departments",
                    icon: icons.teacher,
                    breadcrumbs: true,
                },
                {
                    id: "manufacturers",
                    title: "Manufacturers",
                    type: "item",
                    url: "/master-data/manufacturers",
                    icon: icons.element3,
                    breadcrumbs: true,
                },
                {
                    id: "asset-descriptions",
                    title: "Asset Descriptions",
                    type: "item",
                    url: "/master-data/asset-descriptions",
                    icon: icons.doc,
                    breadcrumbs: true,
                },
                {
                    id: "existing-assets",
                    title: "Existing Assets",
                    type: "item",
                    url: "/master-data/existing-assets",
                    icon: icons.box,
                    breadcrumbs: true,
                },
                {
                    id: "custom-attributes",
                    title: "Custom Attributes",
                    type: "item",
                    url: "/master-data/custom-attributes",
                    icon: icons.setting,
                    breadcrumbs: true,
                },
                {
                    id: "conditions",
                    title: "Conditions",
                    type: "item",
                    url: "/master-data/conditions",
                    icon: icons.task,
                    breadcrumbs: true,
                },
                {
                    id: "capacity-uoms",
                    title: "Capacity UoMs",
                    type: "item",
                    url: "/master-data/capacity-uoms",
                    icon: icons.category,
                    breadcrumbs: true,
                },
                {
                    id: "photo-types",
                    title: "Photo Types",
                    type: "item",
                    url: "/master-data/photo-types",
                    icon: icons.camera,
                    breadcrumbs: true,
                },
                {
                    id: "tag-conditions",
                    title: "Tag Conditions",
                    type: "item",
                    url: "/master-data/tag-conditions",
                    icon: icons.tag,
                    breadcrumbs: true,
                },
            ],
        },
    ],
};

export default masterDataItem;
